import {gql} from "@apollo/client";
import {createEstablishmentMutation, getAllEstablishmentsQuery} from "./establishmentGql";
import filterDataGql, {executeQueryUtil} from "../utils/gqlUtil";
import apolloClient from "../apolloClient/ApolloClient";
import md5 from 'crypto-js/md5';
import {decode as base64_decode, encode as base64_encode} from "base-64";
import momentTz from "moment-timezone";

const common = `
  id
  optionsJsCode
  series
  error
  logs
`

function getItemId(chartImplementationId, filter) {
    if (filter?.filterType === "filterSingleDay") {
        return chartImplementationId + "-filterSingleDay-" + filter.singleDay.format("YYYY-MM-DD");
    }
    else if (filter?.filterType === "filterWeek") {
        return chartImplementationId + "-filterWeek-" +
            momentTz(filter.singleDay).startOf('isoWeek').format("YYYY-MM-DD");
    }
}

export const getChartDataQuery = (brandId, establishmentIds, chartImplementationId, data) => {
    // getChartData(brandId: ID!, establishmentId: ID!, chartImplementationId: ID!, jsonData: String): ChartData
    let input = JSON.stringify(data);
    let base64Encode = base64_encode(input);
    const dataHash = md5(base64Encode).toString();
    let queryString = ` query {
      getChartData(brandId: "${brandId}", establishmentIds: "${establishmentIds}", 
      chartImplementationId: "${chartImplementationId}", dataHash: ,"${dataHash}" jsonData: "${base64Encode}") {
        ${common}
      }
    `;
    return gql `
   ${queryString}}
  `;
}

// export const getChartDataQueryRefresh = (brandId, establishmentIds, chartImplementationId, data) => {
//     // getChartData(brandId: ID!, establishmentId: ID!, chartImplementationId: ID!, jsonData: String): ChartData
//     let input = JSON.stringify(data);
//     let base64Encode = base64_encode(input);
//     const dataHash = md5(base64Encode).toString();
//     let queryString = ` query {
//       getChartData(brandId: "${brandId}", establishmentIds: "${establishmentIds}",
//       chartImplementationId: "${chartImplementationId}", dataHash: ,"${dataHash}" jsonData: "${base64Encode}") {
//         ${common}
//       },
//       fetchPolicy: "network-only"
//     `;
//     return gql `
//    ${queryString}}
//   `;
// }

export const clearChartDataCache = (brandId, establishmentId, chartImplementationId, data) => {
    const dataHash = md5(base64_encode(JSON.stringify(data))).toString();
    const cacheFields = apolloClient.cache.extract();
    let entries = Object.entries(cacheFields);
    try {
        apolloClient.cache.evict({
            fieldName: 'getChartData',
            args: {
                brandId,
                establishmentId,
                chartImplementationId,
                dataHash: dataHash,
                jsonData: base64_encode(JSON.stringify(data)),
            }
        });

        apolloClient.cache.gc(); // Nettoie le cache des entrées orphelines
    } catch (e) {
        console.error("Erreur lors de la purge du cache getChartData:", e);
    }
};

export const clearChartDataCacheByImplementationId = (chartImplementationId, filter) => {
    try {
        const id = "ChartData:" + getItemId(chartImplementationId, filter);
        const cacheFields = apolloClient.cache.extract();
        let entries = Object.entries(cacheFields);
        console.log("Trying to evict cache id:", id);

        const result = apolloClient.cache.evict({ id: id, fieldName: 'getChartData' });
        console.log("Eviction result:", result);

        apolloClient.cache.gc();

    } catch (e) {
        console.error("Erreur lors du nettoyage du cache pour chartImplementationId:", e);
    }
};









